<template>
  <section
    :class="{
      'faq-accordion-component': true,
    }"
  >
    <div :class="{ 'container mx-auto px-0': true }">
      <Padding :padding>
        <FAQAccordion
          v-if="props.FAQAccordion"
          v-bind="props.FAQAccordion"
        />
      </Padding>
    </div>
  </section>
</template>

<script setup lang="ts">
import FAQAccordion from '~/components/Atoms/Accordion/FAQAccordion.vue';
import Padding from '~/components/Atoms/Padding/Padding.vue';
import type { PortableTextFAQAccordion } from '~/sanity/types';
const props = defineProps<PortableTextFAQAccordion>();
</script>

<style></style>
